import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import ResetPasswordForm from "../../components/auth/ResetPasswordForm";

const ResetPasswordPage = () => {
  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bg="var(--color-bg)"
      px={4}
      py={12}
    >
      <ResetPasswordForm />
    </Flex>
  );
};

export default ResetPasswordPage;